import { Icon } from "@trustpilot/businessapp-patternlibrary";
import { arrowRight_16 as arrowRight, calendarRangeArrow_16 as rightArrow } from "@trustpilot/icons";

import styles from "../../styles/sideNav.module.scss";

export const PrimaryNavArrows = () => {
  return (
    <>
      {/* // mobile */}
      <span className={styles.sidebarLinksIconArrowRight}>
        <Icon content={arrowRight} />
      </span>
      {/* desktop */}
      <span className={styles.sidebarLinksIconArrow}>
        <Icon content={rightArrow} />
      </span>
    </>
  );
};
